import { render, staticRenderFns } from "./previewPage.vue?vue&type=template&id=129c0c25&scoped=true"
import script from "./previewPage.vue?vue&type=script&lang=js"
export * from "./previewPage.vue?vue&type=script&lang=js"
import style0 from "./previewPage.vue?vue&type=style&index=0&id=129c0c25&prod&lang=scss&scoped=true"
import style1 from "./previewPage.vue?vue&type=style&index=1&id=129c0c25&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129c0c25",
  null
  
)

export default component.exports